import { Button, Form } from 'react-bootstrap';
import { FaXmark } from 'react-icons/fa6';
import 'styles/global.css';

/**
 * The standard Fusion text input field.
 * @param {{value: string, onChange: (value: string), onBlur: (event: object), className?: string, inputClassName?: string, style?: Object, includeClear?: boolean | true, disabled?: boolean, placeholder?: string}}
 * @returns A react component
 */
export default function FusionInputField({
  value,
  onChange = () => {},
  onBlur = () => {},
  className,
  inputClassName,
  style,
  type = 'text',
  includeClear = true,
  disabled = false,
  placeholder = '',
  label = '',
  required = false,
}) {
  return (
    <Form.Group className={`d-flex flex-column  ${className}`} style={style} disabled={disabled}>
      {label && (
        <Form.Label className="fs-6" htmlFor={label}>
          {label}
          {required && <span className="text-danger ms-1">*</span>}
        </Form.Label>
      )}
      {/* DO NOT MOVE THE CLASSNAME VARIABLE FROM BEING NEXT TO THE BG-PRIMARY */}
      <div
        className={`d-flex w-100 rounded-3 border border-1 border-secondary bg-primary${className}`}
      >
        <Form.Control
          className={`border-0 rounded-0 bg-transparent ${inputClassName}`}
          id={label}
          disabled={disabled}
          type={type}
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          onBlur={(e) => onBlur(e)}
          placeholder={placeholder}
        />
        {includeClear && !disabled && (
          <Button
            className="bg-transparent border-0"
            onClick={() => onChange('')}
            variant="secondary"
          >
            <FaXmark />
          </Button>
        )}
      </div>
    </Form.Group>
  );
}
